import React  from 'react';
import Classes from "classnames";

export default function renderNumberGroupListHeader(id, props) {
    const { data, className } = props;

    const classes = Classes(className, 'gd-field-number-group-list-header');

    return (
        <div className={classes}>
            <div className="group-list-header-value">{!_.isNil(data.value) ? data.value : "Not set"}</div>
        </div>
    );
}